import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist( { key: 'username' } );

export const userState = atom( {
	key: 'userNameTokenState',
	default: '',
	effects_UNSTABLE: [ persistAtom ]
} );